<script setup lang="ts">
import { Progress } from '@/components/ui/progress'
import Skeleton from '@/components/ui/skeleton/Skeleton.vue'

defineProps<{
  fields: { label: string; value: number; color?: string }[]
  skeletons: number
}>()

const getProgressColorClasses = (value: number) => {
  return {
    text: value < 30 ? 'text-red-500' : value < 70 ? 'text-yellow-500' : 'text-green-500',
    bg: value < 30 ? 'bg-red-500' : value < 70 ? 'bg-yellow-500' : 'bg-green-500',
  }
}
</script>

<template>
  <div>
    <div v-if="!fields || fields.length === 0" class="flex flex-col items-center gap-4">
      <div class="w-full flex flex-col gap-2" v-for="i in skeletons" :key="i">
        <div class="flex justify-between">
          <Skeleton class="w-[180px] h-3 bg-primary" />
          <Skeleton class="w-[35px] h-3 bg-primary" />
        </div>
        <Skeleton class="w-full h-3 bg-primary" />
      </div>
    </div>
    <div v-else class="grid gap-3">
      <div class="w-full" v-for="(field, index) in fields" :key="index">
        <div class="flex items-center justify-between mb-1 text-sm">
          <span>{{ field.label }}</span>
          <span :class="getProgressColorClasses(field.value).text"> {{ field.value }}% </span>
        </div>
        <Progress :model-value="field.value" :color="getProgressColorClasses(field.value).bg" />
      </div>
    </div>
  </div>
</template>
